<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ schematicId !== '' ? 'Edit Schematic ' + schematicId : 'Create Schematic' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="schematicId" bottom left>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click.stop="dialogDelete = true">
            <v-list-tile-title>Delete</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-form ref="form" v-model="frmValid" lazy-validation>
        <v-container fluid grid-list-lg class="pa-3">
          <v-layout row wrap>
            <v-flex xs12>
              <div style="max-width:300px;">
                <input
                  type="file"
                  style="display: none"
                  ref="schematicImage"
                  accept="image/*"
                  @change="onSchematicFilePicked"
                  @click="$refs.schematicImage.value = null"
                >
                <v-img v-if="image && image.mediumUrl" :src="image.mediumUrl" contain aspect-ratio="1.2" class="mb-2"></v-img>
                <v-btn
                  outline
                  @click="pickSchematicFile"
                >
                  {{ image && image.mediumUrl ? 'change image' : 'add image' }}
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="txtName"
                :rules="[v => !!v || 'Name is required']"
                :counter="255"
                label="Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="cboDeviceType"
                :items="deviceTypes"
                :rules="[v => !!v || 'Please select device type']"
                label="Device Type"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="cboBrandId"
                :items="brands"
                item-text="brandName"
                item-value="brandId"
                :rules="[v => !!v || 'Please select brand']"
                label="Brand"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="cboStatus"
                :items="statuses"
                item-text="text"
                item-value="value"
                :rules="[v => !!v || 'Please select status']"
                label="Status"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <v-card class="mb-4">
                <v-container>
                  <h3 class="headline font-weight-bold mb-0 text-xs-left">
                    PCB
                  </h3>
                  <div>Create a PCB for this device</div>
                </v-container>
                <input
                  type="file"
                  style="display: none"
                  ref="pcbImage"
                  accept="image/*"
                  @change="onPcbFilePicked"
                  @click="$refs.pcbImage.value = null"
                >
                <v-container v-for="(pcb, pcbIndex) in pcbs" :key="pcbIndex">
                  <v-layout fluid wrap>
                    <v-flex xs1 class="text-xs-center">
                      <v-btn icon large round outline :disabled="pcbIndex === 0" @click="movePcbUp(pcbIndex)"><v-icon>expand_less</v-icon></v-btn>
                      <v-btn icon large round outline :disabled="pcbIndex >= (pcbs.length - 1)" @click="movePcbDown(pcbIndex)"><v-icon>expand_more</v-icon></v-btn>
                      <v-btn icon round outline class="mt-5 grey--text text--darken-1" @click="showAddPcbDialog(pcbIndex)"><v-icon>image</v-icon></v-btn>
                      <v-btn icon round outline class="grey--text text--darken-1" @click="removePcb(pcbIndex)"><v-icon>delete</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs11>
                      <schematic-pcb :pcb="pcb"/>
                    </v-flex>
                  </v-layout>
                </v-container>
                <div class="pa-5">
                  <v-btn
                    outline
                    @click="showAddPcbDialog()"
                  >
                    <v-icon>add</v-icon>
                    Add PCB
                  </v-btn>
                </div>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-5">
              <v-btn
                large
                block
                color="primary"
                :disabled="!frmValid"
                @click="submit"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-dialog v-model="dialogAddPcbImage" max-width="290">
        <v-card>
          <v-card-title class="pb-0">
            <h2>{{ replaceImageForPcbIndex !== null ? 'Change PCB Image' : 'Add PCB' }}</h2>
          </v-card-title>
          <v-card-text class="pt-3">
            <v-container class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center pa-0">
                  <v-form ref="formPcbImage" v-model="frmAddPcbImageValid" enctype="multipart/form-data" lazy-validation>
                    <div v-for="(image, imageIndex) in pcbImageUploads" :key="imageIndex">
                      <div>
                        <v-img :src="image.url" contain />
                      </div>
                      <div>
                        <v-text-field
                          placeholder="Enter PCB Name"
                          v-model="image.description"
                          :counter="100"
                          :rules="[v => !!v || 'Description is required', v => (v && v.length >= 3) || 'Description must be 3 characters or more']"
                          required
                        ></v-text-field>
                      </div>
                    </div>
                    <input
                      type="file"
                      style="display: none"
                      ref="pcbImage"
                      accept="image/*"
                      @change="onPcbFilePicked"
                      @click="$refs.pcbImage.value = null"
                    >
                    <v-btn
                      block
                      color="primary"
                      v-if="pcbImageUploads.length > 0"
                      :disabled="!frmAddPcbImageValid"
                      @click="submitPcbImage"
                    >
                      Add
                    </v-btn>
                    <v-btn
                      block
                      v-else
                      @click="pickPcbFile"
                    >
                      Select PCB Image
                    </v-btn>
                    <!-- <v-switch
                      v-if="pcbImageUploads.length > 0"
                      v-model="switchAddWatermarkToPcb"
                      label="Add Watermark"
                      color="primary"
                      class="ml-3"
                    ></v-switch> -->
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="title">Confirm to delete this schematic?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteSchematic"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}

.context-menu {
  border: 1px solid #fff;
  padding: 10px;
  position: fixed;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import SchematicPcb from '@/components/SchematicPcb.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: {
    schematicId: {
      type: String,
      default: '',
      required: false
    }
  },
  components: {
    SideDrawer,
    SchematicPcb,
    Loading
  },
  data () {
    return {
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      frmValid: true,
      dialogAddSchematicImage: false,
      frmAddSchematicImageValid: false,
      switchAddWatermarkToSchematic: true,
      schematicImageUploads: [],
      txtName: '',
      image: {},
      cboDeviceType: '',
      deviceTypes: [
        {
          text: 'Phone',
          value: 'phone'
        },
        {
          text: 'Tablet',
          value: 'tablet'
        },
        {
          text: 'PC',
          value: 'pc'
        }
      ],
      cboBrandId: '',
      brands: [],
      cboStatus: 'active',
      statuses: [
        {
          text: 'Active',
          value: 'active'
        },
        {
          text: 'Disabled',
          value: 'disabled'
        }
      ],
      dialogDelete: false,
      pcbs: [],
      selectedPcbIndex: null,
      dialogAddPcbImage: false,
      frmAddPcbImageValid: false,
      switchAddWatermarkToPcb: false,
      pcbImageUploads: [],
      replaceImageForPcbIndex: null
    }
  },

  mounted () {
    this.getBrands()
    this.openDrawerForDesktop()
    if (this.schematicId !== '') {
      this.getSchematic(this.schematicId)
    }
  },

  methods: {
    movePcbUp: function (pcbIndex) {
      console.log('movePcbUp', pcbIndex)
      if (pcbIndex > 0 && pcbIndex <= (this.pcbs.length - 1)) {
        let pcbs = this.pcbs.map((x) => x)
        let tmp = pcbs[pcbIndex - 1]
        pcbs[pcbIndex - 1] = pcbs[pcbIndex]
        pcbs[pcbIndex] = tmp
        this.pcbs = pcbs
        console.log(this.pcbs)
      }
    },
    movePcbDown: function (pcbIndex) {
      console.log('movePcbDown', pcbIndex)
      if (pcbIndex >= 0 && pcbIndex <= (this.pcbs.length - 2)) {
        let pcbs = this.pcbs.map((x) => x)
        let tmp = pcbs[pcbIndex + 1]
        pcbs[pcbIndex + 1] = pcbs[pcbIndex]
        pcbs[pcbIndex] = tmp
        this.pcbs = pcbs
        console.log(this.pcbs)
      }
    },
    pickSchematicFile: function () {
      this.$refs.schematicImage.click()
    },
    onSchematicFilePicked: function (e) {
      console.log('onSchematicFilePicked')
      const files = e.target.files
      console.log(files)
      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          var _this = this
          _this.schematicImageUploads = []
          _this.getImageDataAndSetOrientation(files[i], function (imgBase64) {
            _this.schematicImageUploads.push({
              name: files[i].name,
              url: imgBase64,
              file: files[i]
            })
            _this.submitSchematicImage()
          })
        }
      }
    },
    submitSchematicImage: function () {
      var _this = this
      _this.loading = true
      var formData = new FormData()
      formData.append('isWatermark', 'true')
      formData.append('imageFile', _this.schematicImageUploads[0].file, _this.schematicImageUploads[0].name)
      formData.append('description', 'Schematic')
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/schematic/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.image = resp.data.data.imageFile
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showAddPcbDialog: function (pcbIndex = null) {
      this.replaceImageForPcbIndex = pcbIndex
      this.pcbImageUploads = []
      this.pickPcbFile()
      this.switchAddWatermarkToPcb = false
      this.dialogAddPcbImage = true
    },
    pickPcbFile: function () {
      this.$refs.pcbImage.click()
    },
    onPcbFilePicked: function (e) {
      const files = e.target.files
      console.log(files)
      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          var _this = this
          _this.getImageDataAndSetOrientation(files[i], function (imgBase64) {
            _this.pcbImageUploads.push({
              name: files[i].name,
              url: imgBase64,
              file: files[i],
              description: (_this.replaceImageForPcbIndex !== null ? _this.pcbs[_this.replaceImageForPcbIndex].name : '')
            })
          })
        }
      }
    },
    submitPcbImage: function () {
      var _this = this
      if (_this.$refs.formPcbImage.validate()) {
        _this.loading = true
        var formData = new FormData()
        // dont set product id yet, bcos product not saved yet
        // if (_this.productId) {
        //   formData.append('productId', _this.productId)
        // }
        formData.append('isWatermark', (_this.switchAddWatermarkToPcb ? 'true' : 'false'))
        formData.append('imageFile', _this.pcbImageUploads[0].file, _this.pcbImageUploads[0].name)
        formData.append('description', _this.pcbImageUploads[0].description)
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/schematic/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(resp => {
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              if (_this.replaceImageForPcbIndex === null) {
                _this.pcbs.push({
                  pcbId: '',
                  image: resp.data.data.imageFile,
                  name: resp.data.data.imageFile.description,
                  orderSequence: 0,
                  status: 'active',
                  components: []
                })
              } else {
                _this.pcbs[_this.replaceImageForPcbIndex].image = resp.data.data.imageFile
                _this.pcbs[_this.replaceImageForPcbIndex].name = resp.data.data.imageFile.description
              }
              _this.dialogAddPcbImage = false
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    removePcb: function (pcbIndex) {
      let pcbs = this.pcbs.map((x) => x)
      pcbs.splice(pcbIndex, 1)
      this.pcbs = pcbs
    },
    removeProduct: function (productId) {
      var _this = this
      const pos = _this.cboProducts.map(e => e.productId).indexOf(productId)
      console.log('pos: ' + pos)
      _this.cboProducts.splice(pos, 1)
      _this.cboProducts = [..._this.cboProducts]
    },
    deleteSchematic: function () {
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/schematic/' + this.schematicId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/schematics')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    showAddCategoryDialog: function () {
      this.frmAddCategoryValid = false
      this.txtAddCategoryId = ''
      this.dialogAddCategory = true
    },
    removeCategory: function (item) {
      this.cboCategories.splice(this.cboCategories.indexOf(item), 1)
      this.cboCategories = [...this.cboCategories]
    },
    getBrands: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/brands')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.brands = resp.data.data
            } else {
              console.log('unable to load brands: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    getSchematic: function (schematicId) {
      if (schematicId !== '') {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/schematic/' + schematicId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.txtName = resp.data.data.name
              this.cboBrandId = resp.data.data.brandId
              this.cboDeviceType = resp.data.data.deviceType
              this.cboStatus = resp.data.data.status
              this.pcbs = resp.data.data.pcbs
              this.image = resp.data.data.image
            } else {
              console.log('unable to load schematic details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    submit () {
      for (let i in this.pcbs) {
        for (let j in this.pcbs[i].components) {
          if (this.pcbs[i].components[j].products.length === 0) {
            window.alert('Products required for component ' + this.pcbs[i].components[j].name)
            return false
          }
        }
      }
      var data = {
        name: this.txtName,
        schematicImageId: this.image.schematicImageId,
        brandId: this.cboBrandId,
        deviceType: this.cboDeviceType,
        status: this.cboStatus,
        pcbs: this.pcbs
      }
      for (let i in data.pcbs) {
        data.pcbs[i].orderSequence = i
        data.pcbs[i].schematicImageId = data.pcbs[i].image.schematicImageId
        delete data.pcbs[i].image
        for (let j in data.pcbs[i].components) {
          let products = []
          for (let k in data.pcbs[i].components[j].products) {
            products.push({
              productId: data.pcbs[i].components[j].products[k].productId
            })
          }
          delete data.pcbs[i].components[j].products
          data.pcbs[i].components[j].products = products
        }
      }
      this.loading = true
      if (this.schematicId !== '') {
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/schematic/' + this.schematicId, data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              router.push('/schematics')
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      } else {
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/schematic', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              router.push('/schematics')
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    }
  }
}
</script>
